export const errorsHandler = (errors, key, title, depth = [], getComponentName = null, customDescription = null) => {
  errors.forEach(err => {
    // avoid multi-catch for same error
    if (!err.alreadyCatched) {
      // set that this already catched
      err.alreadyCatched = true;
      let titleToUse = title;
      let keyToUse = key;
      let indexes = [];
      if (err.path && depth.length > 0) {
        depth.forEach(d => {
          const index = err.path[err.path.length - 1 - d];
          indexes.push(index);
        });
        indexes.forEach((indexNumber, idx) => {
          titleToUse = titleToUse.replace(`{INDEX_${idx}}`, indexNumber + 1);
          keyToUse = keyToUse.replace(`{INDEX_${idx}}`, indexNumber);
        });
        if (getComponentName) {
          titleToUse = titleToUse.replace(`{NAME}`, `"${getComponentName(err.state.ancestors[err.state.ancestors.length - 1], indexes)}"`);
        }
      }
      let message = '';
      switch (err.code) {
        case 'any.empty':
          message = `${titleToUse}: il campo non può essere vuoto.`;
          break;
        case 'any.required':
          message = `${titleToUse}: il campo è obbligatorio.`;
          break;
        case 'any.invalid':
          message = `${titleToUse}: il campo non è valido.`;
          break;
        case 'string.empty':
          message = `${titleToUse}: il campo non può essere vuoto.`;
          break;
        case 'string.required':
          message = `${titleToUse}: il campo è obbligatorio.`;
          break;
        case 'string.min':
          message = `${titleToUse}: il campo deve avere almeno ${err.local.limit} caratter${err.local.limit === 1 ? 'o' : 'i'}.`;
          break;
        case 'string.max':
          message = `${titleToUse}: il campo può avere al massimo ${err.local.limit} caratter${err.local.limit === 1 ? 'o' : 'i'}.`;
          break;
        case 'string.base':
          message = `${titleToUse}: il valore deve essere una stringa.`;
          break;
        case 'array.min':
          message = `${titleToUse}: deve contenere almeno ${err.local.limit} element${err.local.limit === 1 ? 'o' : 'i'}.`;
          break;
        case 'array.max':
          message = `${titleToUse}: può contenere al massimo ${err.local.limit} element${err.local.limit === 1 ? 'o' : 'i'}.`;
          break;
        case 'alternatives.match':
          message = `${titleToUse}: Il campo non è valido`;
          break;
        default:
          console.warn('Error code not handled: ', err.code);
          break;
      }
      if (customDescription) {
        message = `${titleToUse}: ${customDescription}`;
      }
      err.message = JSON.stringify({
        field: keyToUse,
        message: message
      });
    }
  });
  return errors;
};